export const translations = {
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'خدماتنا',
      about: 'من نحن',
      team: 'فريقنا',
      magazine: 'مجلة التمكين',
      contact: 'تواصل معنا'
    },
    hero: {
      title: 'حلول قانونية',
      titleHighlight: 'فخمة ومتطورة',
      titleEnd: 'لعالم الأعمال',
      description: 'نقدم استشارات قانونية احترافية ومبتكرة تواكب التطورات الحديثة في عالم القانون والأعمال، مع فريق من الخبراء المتخصصين والتدريب المتقدم.',
      startNow: 'ابدأ الآن',
      ourServices: 'خدماتنا',
      bookConsultation: 'احجز استشارة الآن',
      trustedExperience: 'خبرة موثوقة',
      yearsExperience: '15+ سنة خبرة',
      quickSolutions: 'حلول سريعة',
      instantResponse: 'استجابة فورية',
      fullPrivacy: 'سرية تامة',
      dataProtection: 'حماية البيانات',
      specializedTeam: 'فريق متخصص',
      legalExperts: 'خبراء قانونيون'
    },
    stats: {
      successfulCases: 'قضية ناجحة',
      yearsExperience: 'سنة خبرة',
      satisfiedClients: 'عميل راضٍ',
      professionalLawyers: 'محامي محترف'
    },
    services: {
      title: 'خدماتنا المتميزة',
      description: 'نقدم مجموعة شاملة من الخدمات القانونية المتطورة التي تلبي احتياجات عملائنا في مختلف المجالات',
      learnMore: 'اعرف المزيد'
    },
    about: {
      title: 'من نحن',
      description1: 'شركة التمكين للاستشارات والخدمات القانونية هي شركة رائدة في تقديم الحلول القانونية المتطورة والمبتكرة. نحن نجمع بين الخبرة العميقة والتقنيات الحديثة لنقدم خدمات قانونية عالية الجودة.',
      description2: 'مع أكثر من 15 عاماً من الخبرة، نفخر بكوننا الشريك القانوني الموثوق للعديد من الشركات والأفراد في المنطقة، مع التزامنا بالأعمال الطوعية والتدريب المتقدم.',
      successfulCases: 'قضية ناجحة',
      successRate: 'معدل النجاح',
      learnMoreAboutUs: 'اعرف المزيد عنا',
      ourVision: 'رؤيتنا',
      visionText: 'أن نكون الشركة الرائدة في تقديم الخدمات القانونية المتطورة والمبتكرة في المنطقة، ونساهم في بناء مجتمع قانوني متقدم يواكب التطورات العالمية من خلال التدريب والأعمال الطوعية.'
    },
    team: {
      title: 'فريق الخبراء',
      description: 'فريق من المحامين والخبراء القانونيين المتميزين الذين يجمعون بين الخبرة العملية والمعرفة الأكاديمية'
    },
    magazine: {
      title: 'مجلة التمكين',
      description: 'مصدرك الموثوق للأخبار القانونية والتحليلات المتخصصة والقوانين الحديثة',
      legalAnalysis: 'تحليلات قانونية',
      legalAnalysisDesc: 'مقالات وشرح قوانين جديدة والتعديلات',
      newsLegislation: 'أخبار وتشريعات',
      newsLegislationDesc: 'تغطية للقوانين الحديثة والتعليمات وقرارات المحكمة وأخبار عن الشركة وفعالياتها والندوات',
      readMore: 'اقرأ المزيد',
      comingSoon: 'قريباً'
    },
    contact: {
      title: 'تواصل معنا',
      description: 'نحن هنا لمساعدتك في جميع احتياجاتك القانونية. تواصل معنا اليوم للحصول على استشارة',
      contactUs: 'تواصل معنا',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      serviceType: 'نوع الخدمة المطلوبة',
      selectService: 'نوع الخدمة المطلوبة',
      description_field: 'وصف المشكلة أو الاستفسار',
      submit: 'إرسال الطلب',
      address: 'العنوان',
      addressText: 'اليرموك . الاربع شوارع . تقاطع الاردن',
      phoneNumber: 'رقم الهاتف',
      emailAddress: 'البريد الإلكتروني',
      socialMedia: 'مواقع التواصل الاجتماعي',
      socialHandle: '@thisistamkeen'
    },
    footer: {
      companyName: 'التمكين',
      tagline: 'للاستشارات والخدمات القانونية',
      description: 'شركة رائدة في تقديم الخدمات القانونية المتطورة والمبتكرة مع التزام قوي بالأعمال الطوعية والتدريب المتقدم.',
      quickLinks: 'روابط سريعة',
      ourServices: 'خدماتنا',
      contactInfo: 'معلومات التواصل',
      copyright: '© 2024 شركة التمكين للاستشارات والخدمات القانونية. جميع الحقوق محفوظة.'
    },
    common: {
      other: 'أخرى'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Our Services',
      about: 'About Us',
      team: 'Our Team',
      magazine: 'Tamkeen Magazine',
      contact: 'Contact Us'
    },
    hero: {
      title: 'Luxurious & Modern',
      titleHighlight: 'Legal Solutions',
      titleEnd: 'for Business World',
      description: 'We provide professional and innovative legal consultations that keep pace with modern developments in the world of law and business, with a team of specialized experts and advanced training.',
      startNow: 'Start Now',
      ourServices: 'Our Services',
      bookConsultation: 'Book Consultation Now',
      trustedExperience: 'Trusted Experience',
      yearsExperience: '15+ Years Experience',
      quickSolutions: 'Quick Solutions',
      instantResponse: 'Instant Response',
      fullPrivacy: 'Full Privacy',
      dataProtection: 'Data Protection',
      specializedTeam: 'Specialized Team',
      legalExperts: 'Legal Experts'
    },
    stats: {
      successfulCases: 'Successful Cases',
      yearsExperience: 'Years of Experience',
      satisfiedClients: 'Satisfied Clients',
      professionalLawyers: 'Professional Lawyers'
    },
    services: {
      title: 'Our Distinguished Services',
      description: 'We offer a comprehensive range of advanced legal services that meet our clients\' needs in various fields',
      learnMore: 'Learn More'
    },
    about: {
      title: 'About Us',
      description1: 'Tamkeen Legal Consulting and Services Company is a leading company in providing advanced and innovative legal solutions. We combine deep experience and modern technologies to provide high-quality legal services.',
      description2: 'With more than 15 years of experience, we are proud to be the trusted legal partner for many companies and individuals in the region, with our commitment to voluntary work and advanced training.',
      successfulCases: 'Successful Cases',
      successRate: 'Success Rate',
      learnMoreAboutUs: 'Learn More About Us',
      ourVision: 'Our Vision',
      visionText: 'To be the leading company in providing advanced and innovative legal services in the region, and to contribute to building an advanced legal community that keeps pace with global developments through training and voluntary work.'
    },
    team: {
      title: 'Expert Team',
      description: 'A team of distinguished lawyers and legal experts who combine practical experience and academic knowledge'
    },
    magazine: {
      title: 'Tamkeen Magazine',
      description: 'Your trusted source for legal news, specialized analysis, and modern laws',
      legalAnalysis: 'Legal Analysis',
      legalAnalysisDesc: 'Articles, new laws explanations, and amendments',
      newsLegislation: 'News & Legislation',
      newsLegislationDesc: 'Coverage of modern laws, instructions, court decisions, company news, events, and seminars',
      readMore: 'Read More',
      comingSoon: 'Coming Soon'
    },
    contact: {
      title: 'Contact Us',
      description: 'We are here to help you with all your legal needs. Contact us today for a consultation',
      contactUs: 'Contact Us',
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      serviceType: 'Service Type Required',
      selectService: 'Service Type Required',
      description_field: 'Problem Description or Inquiry',
      submit: 'Submit Request',
      address: 'Address',
      addressText: 'Yarmouk, Four Streets, Jordan Intersection',
      phoneNumber: 'Phone Number',
      emailAddress: 'Email Address',
      socialMedia: 'Social Media',
      socialHandle: '@thisistamkeen'
    },
    footer: {
      companyName: 'Tamkeen',
      tagline: 'Legal Consulting & Services',
      description: 'A leading company in providing advanced and innovative legal services with a strong commitment to voluntary work and advanced training.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contactInfo: 'Contact Information',
      copyright: '© 2024 Tamkeen Legal Consulting and Services Company. All rights reserved.'
    },
    common: {
      other: 'Other'
    }
  }
};

export const servicesData = {
  ar: [
    {
      id: 'contracts',
      title: 'صياغة العقود',
      description: 'صياغة ومراجعة العقود القانونية بأعلى معايير الدقة والاحترافية',
      details: {
        title: 'صياغة العقود',
        description: 'نقدم خدمات صياغة ومراجعة العقود القانونية بأعلى معايير الدقة والاحترافية.',
        features: [
          'صياغة عقود البيع والشراء',
          'عقود العمل والتوظيف',
          'عقود الشراكة التجارية',
          'عقود الإيجار والتأجير',
          'مراجعة وتعديل العقود الموجودة'
        ]
      }
    },
    {
      id: 'consultation',
      title: 'الاستشارات القانونية',
      description: 'استشارات قانونية متخصصة في جميع فروع القانون المدني والتجاري',
      details: {
        title: 'الاستشارات القانونية',
        description: 'استشارات قانونية متخصصة في جميع فروع القانون المدني والتجاري من خبراء معتمدين.',
        features: [
          'استشارات فورية عبر الهاتف',
          'استشارات مكتوبة مفصلة',
          'جلسات استشارية شخصية',
          'استشارات قانونية للشركات',
          'متابعة مستمرة للقضايا'
        ]
      }
    },
    {
      id: 'company',
      title: 'تأسيس الشركات',
      description: 'خدمات تأسيس الشركات وتنظيم هياكلها القانونية والإدارية',
      details: {
        title: 'تأسيس الشركات',
        description: 'خدمات شاملة لتأسيس الشركات وتنظيم هياكلها القانونية والإدارية وفقاً للقوانين العراقية.',
        features: [
          'تأسيس الشركات المحدودة',
          'تأسيس الشركات المساهمة',
          'إعداد النظام الأساسي',
          'التسجيل في دائرة تسجيل الشركات',
          'الحصول على التراخيص المطلوبة'
        ]
      }
    },
    {
      id: 'litigation',
      title: 'التقاضي',
      description: 'تمثيل قانوني محترف في جميع مراحل التقاضي',
      details: {
        title: 'التقاضي',
        description: 'تمثيل قانوني محترف أمام جميع المحاكم والجهات القضائية مع ضمان أفضل النتائج.',
        features: [
          'التمثيل أمام المحاكم المدنية',
          'التمثيل أمام المحاكم التجارية',
          'التمثيل في قضايا الأحوال الشخصية',
          'التمثيل أمام محاكم الاستئناف',
          'التمثيل أمام محكمة التمييز'
        ]
      }
    },
    {
      id: 'arbitration',
      title: 'التحكيم والوساطة',
      description: 'حلول بديلة لفض النزاعات عبر التحكيم والوساطة القانونية',
      details: {
        title: 'التحكيم والوساطة',
        description: 'حلول بديلة لفض النزاعات عبر التحكيم والوساطة القانونية بطريقة سريعة وفعالة.',
        features: [
          'التحكيم التجاري المحلي',
          'التحكيم الدولي',
          'الوساطة في النزاعات المدنية',
          'تنفيذ أحكام التحكيم',
          'إعداد اتفاقيات التحكيم'
        ]
      }
    },
    {
      id: 'risk',
      title: 'إدارة المخاطر',
      description: 'تحليل وإدارة المخاطر القانونية للشركات والمؤسسات',
      details: {
        title: 'إدارة المخاطر',
        description: 'تحليل وإدارة المخاطر القانونية للشركات والمؤسسات لضمان الامتثال القانوني.',
        features: [
          'تقييم المخاطر القانونية',
          'وضع استراتيجيات الحماية',
          'مراجعة السياسات الداخلية',
          'التدريب على الامتثال',
          'المتابعة الدورية للمخاطر'
        ]
      }
    },
    {
      id: 'training',
      title: 'التدريب',
      description: 'برامج تدريبية متخصصة في المجالات القانونية',
      details: {
        title: 'التدريب',
        description: 'برامج تدريبية احترافية للمحامين والقانونيين ومنسوبي الشركات.',
        features: [
          'دورات قانونية متخصصة',
          'تدريب الموظفين على الامتثال',
          'ورش عمل قانونية',
          'برامج التطوير المهني',
          'تدريب على المهارات القانونية'
        ]
      }
    }
  ],
  en: [
    {
      id: 'contracts',
      title: 'Contract Drafting',
      description: 'Drafting and reviewing legal contracts with the highest standards of accuracy and professionalism',
      details: {
        title: 'Contract Drafting',
        description: 'We provide contract drafting and review services with the highest standards of accuracy and professionalism.',
        features: [
          'Sale and purchase contracts',
          'Employment and labor contracts',
          'Business partnership contracts',
          'Lease and rental contracts',
          'Review and modification of existing contracts'
        ]
      }
    },
    {
      id: 'consultation',
      title: 'Legal Consultations',
      description: 'Specialized legal consultations in all branches of civil and commercial law',
      details: {
        title: 'Legal Consultations',
        description: 'Specialized legal consultations in all branches of civil and commercial law from certified experts.',
        features: [
          'Instant phone consultations',
          'Detailed written consultations',
          'Personal consultation sessions',
          'Corporate legal consultations',
          'Continuous case follow-up'
        ]
      }
    },
    {
      id: 'company',
      title: 'Company Formation',
      description: 'Company formation services and organizing their legal and administrative structures',
      details: {
        title: 'Company Formation',
        description: 'Comprehensive services for company formation and organizing their legal and administrative structures according to Iraqi laws.',
        features: [
          'Limited liability company formation',
          'Joint-stock company formation',
          'Articles of incorporation preparation',
          'Company registration department filing',
          'Obtaining required licenses'
        ]
      }
    },
    {
      id: 'litigation',
      title: 'Litigation',
      description: 'Professional legal representation in all stages of litigation',
      details: {
        title: 'Litigation',
        description: 'Professional legal representation before all courts and judicial authorities ensuring the best results.',
        features: [
          'Representation before civil courts',
          'Representation before commercial courts',
          'Representation in personal status cases',
          'Representation before appeals courts',
          'Representation before cassation court'
        ]
      }
    },
    {
      id: 'arbitration',
      title: 'Arbitration & Mediation',
      description: 'Alternative dispute resolution through arbitration and legal mediation',
      details: {
        title: 'Arbitration & Mediation',
        description: 'Alternative dispute resolution through arbitration and legal mediation in a fast and effective manner.',
        features: [
          'Local commercial arbitration',
          'International arbitration',
          'Mediation in civil disputes',
          'Arbitration award enforcement',
          'Arbitration agreement preparation'
        ]
      }
    },
    {
      id: 'risk',
      title: 'Risk Management',
      description: 'Analysis and management of legal risks for companies and institutions',
      details: {
        title: 'Risk Management',
        description: 'Analysis and management of legal risks for companies and institutions to ensure legal compliance.',
        features: [
          'Legal risk assessment',
          'Protection strategies development',
          'Internal policy review',
          'Compliance training',
          'Periodic risk monitoring'
        ]
      }
    },
    {
      id: 'training',
      title: 'Training',
      description: 'Specialized training programs in legal fields',
      details: {
        title: 'Training',
        description: 'Professional training programs for lawyers, legal professionals, and company staff.',
        features: [
          'Specialized legal courses',
          'Employee compliance training',
          'Legal workshops',
          'Professional development programs',
          'Legal skills training'
        ]
      }
    }
  ]
};

export const teamData = {
  ar: [
    {
      id: 1,
      name: 'المحامي أحمد الجبوري',
      position: 'المدير المفوض',
      experience: 'خبرة 15 عاماً في القانون المدني والتجاري',
      image: 'https://customer-assets.emergentagent.com/job_law-advisors-1/artifacts/fvl7s5j7_WhatsApp%20Image%202025-11-28%20at%2002.00.57.jpeg',
      featured: true
    }
  ],
  en: [
    {
      id: 1,
      name: 'Lawyer Ahmed Al-Jubouri',
      position: 'Managing Director',
      experience: '15 years of experience in civil and commercial law',
      image: 'https://customer-assets.emergentagent.com/job_law-advisors-1/artifacts/fvl7s5j7_WhatsApp%20Image%202025-11-28%20at%2002.00.57.jpeg',
      featured: true
    }
  ]
};

export const statsData = [
  { number: '500+', key: 'successfulCases' },
  { number: '15+', key: 'yearsExperience' },
  { number: '300+', key: 'satisfiedClients' },
  { number: '20+', key: 'professionalLawyers' }
];

export const contactInfo = {
  ar: {
    address: 'اليرموك . الاربع شوارع . تقاطع الاردن',
    phone: '07815554545',
    email: 'Tamkeen774@gmail.com',
    social: '@thisistamkeen'
  },
  en: {
    address: 'Yarmouk, Four Streets, Jordan Intersection',
    phone: '07815554545',
    email: 'Tamkeen774@gmail.com',
    social: '@thisistamkeen'
  }
};
